import React from 'react'
import Shop from './Shop'
import Othersoption from '../Auth/Othersoption'
import Intouch from '../Index/Touch'
import Footer from '../Footer/Footer'

const ShopContainer = () => {
  return (
    <div className='flex flex-col bg-[#06000A] overflow-hidden'>
        <Shop/>
        <Othersoption/>
        <Intouch/>
        <Footer/>
    </div>
  )
}

export default ShopContainer